module.exports = __webpack_public_path__ + "static/media/M63ws.63e77d67.pdf";